import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import ScrollToTop from './components/ScrollToTop';
import i18n from './i18n';
// Routes
import routesPages from './config/routes/routes';
// Style
import './App.css';

import Admin from './pages/admin/Admin';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/login" element={<Navigate to="/admin/login" replace />} />
          <Route path="/admin/*" element={<Admin />} />+
          
          {routesPages.map((route, index) => (
            <Route key={index} path={route.path} element={<route.layout />}>
              <Route path={route.path} element={<route.component path={route.path} title={route.title} breadTitle={route.breadTitle} />} />
            </Route>
          ))}
        </Routes>
      </BrowserRouter>
    </I18nextProvider >
  );
}

export default App;
